// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3QGBH","signatureBlock":"Footer_signatureBlock__2k6Lc","signature":"Footer_signature__19mHf"};